import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4460fd25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-container" }
const _hoisted_2 = { class: "route-container__right" }
const _hoisted_3 = {
  key: 0,
  class: "right-loading-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right-loading__message" }, "空间加载中...", -1))

import { useRoute } from 'vue-router'
import {
  computed,
  ref,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  watch
} from 'vue'
import { useGroupStore } from '@/store/group'
import { useUserStore } from '@/store/user'
import useTeamShare from '@teams/common/hooks/useTeamShare'
import Loading from '@teams/common/components/loading'
import GroupPanel from '@/components/groupPanel'
import useViewConfig from '@/hooks/useViewConfig'
import {
  useSingleGroupMemento,
  GroupOriginatorEvtBusListenerType
} from '@teams/common/hooks/useMemento/group'
import { useDrawer } from '@/components/drawer'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'
import { showLoading, closeLoading, evtBus, EvtBusListenerType } from './hooks'
import { useWindowMessage } from '@teams/common/hooks/useWindowMessage'
import { useAppDialog } from '@/components/appDialog'
import { useContextMenu } from '@/components/contextMenu'
import { useMultiDialog } from '@/components/multiDialogsProvider'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { initMessage } = useWindowMessage()
const handleEvtBus: EvtBusListenerType = eventName => {
  const handlers: {
    [key in typeof eventName]?: (...args: unknown[]) => unknown
  } = {
    showLoading() {
      pageLoading.value = true
    },
    closeLoading() {
      pageLoading.value = false
    }
  }
  handlers[eventName]?.()
}

// message初始化后可在其他ts内使用
initMessage()

onMounted(() => {
  evtBus.on(handleEvtBus)
})
onBeforeUnmount(() => {
  evtBus.off(handleEvtBus)
})

const pageLoading = ref(false)

const route = useRoute()
const singleGroupMemento = useSingleGroupMemento()
const { currentAccountInfo } = useAccountChange({ init: true })
const changeGroupHandler: GroupOriginatorEvtBusListenerType = evtName => {
  if (evtName === 'startChangeGroup' || evtName === 'startChangeUser') {
    showLoading()
  }
  if (evtName === 'finishChangeGroup' || evtName === 'finishChangeUser') {
    closeLoading()
  }
}
onBeforeMount(() => {
  singleGroupMemento.originator.evtBus.on(changeGroupHandler)
})
onBeforeUnmount(() => {
  singleGroupMemento.originator.evtBus.off(changeGroupHandler)
})

const {
  shouldStickyGroupPanel,
  toggleStickyGroupPanel,
  showCustomPanel,
  closeCustomPanel
} = useViewConfig()

const { settingInfo } = useTeamShare()
const groupStore = useGroupStore()
const userStore = useUserStore()
const drawerProvider = useDrawer()
const dialog = useAppDialog()
const multiDialog = useMultiDialog()
const { close: closeContextMenu } = useContextMenu()
const routerViewKey = computed(() => {
  // 这里会监听route 每次url改变 都有可能导致routerViewKey改变从而导致重渲
  if (route.name === 'Index') {
    return route.name
  }
  // Error 页不与 groupId 进行强绑定
  return route.name === 'NotFound'
    ? 'NotFound'
    : `${route.name as string}_${groupStore.groupId}`
})
const routerViewName = computed<string>(() => {
  if (
    ['Home', 'Nav'].includes(route?.name as string) &&
    !groupStore?.current?.id
  ) {
    return 'notFound'
  }
  let routeView = 'default'
  if (route.name === 'Home' || route.name === 'Nav') {
    // 访客 &&  私密团队
    if (!userStore.role.isGroupMember && settingInfo.value.private_group) {
      routeView = 'notFound'
    } else if (userStore.role.isGroupMember && userStore.role.disabled) {
      // 已禁用成员
      routeView = 'notFound'
    }
  }
  return routeView
})
// 账号变更时，关闭无用弹窗
const onClosePopUp = () => {
  // 初始页退出登录时关闭抽屉，其余情况保持抽屉状态不变
  if (!route.params.groupId && !currentAccountInfo.value) {
    drawerProvider?.optionsList.value.length && drawerProvider?.close()
    shouldStickyGroupPanel.value && toggleStickyGroupPanel()
  }
  // 对消息弹框的处理
  const eleMessageBox: HTMLElement | null =
    document.querySelector('#k-message-box')
  if (eleMessageBox && getComputedStyle(eleMessageBox).display !== 'none') {
    const mousedownEvent = new MouseEvent('mousedown')
    const mouseupEvent = new MouseEvent('mouseup')
    document.dispatchEvent(mousedownEvent)
    document.dispatchEvent(mouseupEvent)
    document.body.click()
  }
  // 关闭右键
  closeContextMenu()
  // 关闭所有的dialog
  dialog?.close()
  multiDialog.closeAll()
  // 关闭自定义面板
  showCustomPanel.value && closeCustomPanel()
}
watch(
  () => currentAccountInfo.value,
  () => {
    onClosePopUp()
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(shouldStickyGroupPanel))
      ? (_openBlock(), _createBlock(_unref(GroupPanel), {
          key: 0,
          class: "route-container__left"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (pageLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(Loading), { size: 48 }),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createBlock(_component_router_view, {
        key: _unref(routerViewKey),
        name: _unref(routerViewName)
      }, null, 8, ["name"])), [
        [_vShow, !pageLoading.value]
      ])
    ])
  ]))
}
}

})